import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import SEOContent from './components/SEOContent';
import ArticleCards from './components/ArticleCards';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuy.study';

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Kakobuy.study',
  url: siteUrl,
  description: 'Najlepszy przewodnik zakupowy Kakobuy Spreadsheet — kompletny poradnik zakupów z Chin',
  inLanguage: 'pl-PL',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Kakobuy.study',
  url: siteUrl,
  description: 'Najlepszy przewodnik zakupowy Kakobuy Spreadsheet — kompletny poradnik zakupów z Chin dla polskich kupujących',
  sameAs: [
    'https://kaspreadsheet.com/',
  ],
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <SEOContent />
        <ArticleCards />
        <CTASection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
    </>
  );
}